import { TRANSITION_DURATION_IN_SECONDS } from '@constants';
import styled from '@emotion/styled';
import SpinnerAnimation from '@public/assets/SpinnerAnimation.json';
import TickAnimation from '@public/assets/TickAnimation.json';
import { AnimatePresence, Variants, motion } from 'framer-motion';
import Lottie from 'lottie-react';
import { FC } from 'react';

import { useFlowPage } from '../contexts/FlowPageContext';
import { isSuccessFlowPage } from '../utils/validators';

const TICK_SIZE = 18;
const SPINNER_SIZE = TICK_SIZE / 2;

const LoaderContainer = styled.div`
    height: ${TICK_SIZE}vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const AnimatedTickContainer = styled(motion.div)`
    height: ${TICK_SIZE}vh;
    width: ${TICK_SIZE}vh;
`;

const AnimatedSpinnerContainer = styled.div`
    height: ${SPINNER_SIZE}vh;
    width: ${SPINNER_SIZE}vh;
`;

const tickMotion: Variants = {
    initial: { scale: 3, opacity: 0 },
    animate: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: TRANSITION_DURATION_IN_SECONDS,
            ease: 'linear',
            delay: TRANSITION_DURATION_IN_SECONDS * 2,
        },
    },
};

export const FlowPageLoader: FC = () => {
    const { flowPage, process } = useFlowPage();

    return (
        <LoaderContainer>
            {process?.isLoading ? (
                <AnimatedSpinnerContainer>
                    <Lottie animationData={SpinnerAnimation} />
                </AnimatedSpinnerContainer>
            ) : (
                <AnimatePresence>
                    {isSuccessFlowPage(flowPage) && (
                        <AnimatedTickContainer
                            variants={tickMotion}
                            initial='initial'
                            animate='animate'
                        >
                            <Lottie
                                animationData={TickAnimation}
                                loop={false}
                            />
                        </AnimatedTickContainer>
                    )}
                </AnimatePresence>
            )}
        </LoaderContainer>
    );
};
